"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toDictionary = exports.pick = exports.omit = exports.difference = exports.get = exports.merge = void 0;
var merge_1 = __importDefault(require("./merge"));
exports.merge = merge_1.default;
function get(obj, path) {
    path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
    var paths = path.split('.');
    var current = obj;
    for (var i = 0; i < paths.length; ++i) {
        if (current && paths[i] in current) {
            current = current[paths[i]];
        }
        else {
            return;
        }
    }
    return current;
}
exports.get = get;
/**
 * Returns an object with the properties of obj1 that are different in obj2, as they appear in obj2
 */
function difference(obj1, obj2) {
    var diff = {};
    for (var key in obj1) {
        if (obj1[key] !== obj2[key]) {
            diff[key] = obj2[key];
        }
    }
    return diff;
}
exports.difference = difference;
var omit = function (obj) {
    var keys = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        keys[_i - 1] = arguments[_i];
    }
    return Object.keys(obj).reduce(function (acc, key) {
        if (!keys.includes(key)) {
            acc[key] = obj[key];
        }
        return acc;
    }, {});
};
exports.omit = omit;
/**
 * Makes a copy of the source object with only the whitelisted keys
 * and only if these are defined in the object
 * @param source a source object
 * @param keys the list of keys to be extracted from the source object and provided in the response ONLY if these are defined in the source object
 */
function pick(source, keys) {
    var allKeys = Object.keys(source);
    if (!keys) {
        keys = allKeys;
    }
    var r = {};
    var key;
    for (var _i = 0, allKeys_1 = allKeys; _i < allKeys_1.length; _i++) {
        key = allKeys_1[_i];
        if (keys.includes(key)) {
            r[key] = source[key];
        }
    }
    return r;
}
exports.pick = pick;
function toDictionary(arr, options) {
    var _a = __assign({ k: 'id', transform: function (el) { return el; } }, options), k = _a.k, transform = _a.transform;
    var dict = {};
    if (Array.isArray(arr)) {
        for (var i = 0; i < arr.length; i++) {
            var el = arr[i];
            var key = el[k];
            if (typeof key === 'string') {
                dict[key] = transform(el);
            }
        }
    }
    return dict;
}
exports.toDictionary = toDictionary;
//# sourceMappingURL=index.js.map